// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 6C2 4.067 3.567 2.5 5.5 2.5C7.433 2.5 9 4.067 9 6C9 7.52388 8.02611 8.8203 6.66677 9.30081C6.97558 10.0067 7.68018 10.5 8.5 10.5H15.5C17.7091 10.5 19.5 12.2909 19.5 14.5V14.6449C20.9457 15.0752 22 16.4145 22 18C22 19.933 20.433 21.5 18.5 21.5C16.567 21.5 15 19.933 15 18C15 16.4145 16.0543 15.0752 17.5 14.6449V14.5C17.5 13.3954 16.6046 12.5 15.5 12.5H8.5C7.77143 12.5 7.08835 12.3052 6.5 11.9649V14.6449C7.94574 15.0752 9 16.4145 9 18C9 19.933 7.433 21.5 5.5 21.5C3.567 21.5 2 19.933 2 18C2 16.4145 3.05426 15.0752 4.5 14.6449V9.35506C3.05426 8.92479 2 7.58551 2 6Z"}}]};

const GitMergeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'git-merge-filled',
    ref,
    icon: element,
  },
));

GitMergeFilledIcon.displayName = 'GitMergeFilledIcon';

export default GitMergeFilledIcon;
